<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} agencia
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <ng-container *ngIf="service_alert.show">
          <div class="alert alert-{{service_alert.class}} alert-dismissible fade show" role="alert">
            <button type="button" class="close" aria-label="Close" (click)="service_alert.show = false">
              <span aria-hidden="true">×</span>
            </button>
            <strong>¡Datos extraídos!, </strong> {{service_alert.message}}
          </div>
        </ng-container>
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="row">
            <div class="col-lg-9">
              <div class="row">
                <div class="form-group col-lg-8">
                  <label>Nombre comercial agencia<span class="required"></span></label>
                  <input type="text" id="client_tradename" formControlName="tradename" required autofocus
                    class="form-control">
                </div>
                <div class="form-group col-lg-4">
                  <label>N° RUC <span class="required"></span></label>
                  <div class="input-group">
                    <input type="text" id="client_document" formControlName="document" numeric maxlength="11"
                      class="form-control" required>
                    <div class="input-group-append bg-custom">
                      <div class="input-group-text pointer btn-sunat" (click)="extractRuc()"
                        uib-tooltip="Extraer de Sunat"></div>
                    </div>
                  </div>
                </div>
                <div class="form-group col-lg-4">
                  <label>Razón social</label>
                  <input type="text" id="client_fullname" formControlName="fullname" class="form-control">
                </div>
                <div class="form-group col-lg-4">
                  <label>Celular <span class="required"></span></label>
                  <input type="text" formControlName="cellphone" numeric required class="form-control">
                </div>
                <div class="form-group col-lg-4">
                  <label>Teléfono fijo</label>
                  <input type="text" formControlName="telephone" numeric class="form-control">
                </div>
                <div class="form-group col-lg-4">
                  <label>Correo electrónico</label>
                  <input type="email" formControlName="email" class="form-control">
                </div>
                <div class="form-group col-lg-8">
                  <label>Dirección</label>
                  <textarea formControlName="address" rows="1" class="form-control no-resize"></textarea>
                </div>
                <div class="form-group col-lg-8">
                  <label>Anotaciones sobre la agencia</label>
                  <textarea formControlName="annotations" rows="2" class="form-control no-resize"></textarea>
                </div>
              </div>

              <div class="row m-b-20">
                <div class="col-lg-12 m-t-10">
                  <p class="form__group__title"><i class="fas fa-chevron-circle-right m-r-5"></i> Encargados de
                    agencia
                  </p>
                  <span *ngIf="!isEdit" class="badge badge-dark f-s-12"> NOTA: Esta opción se habilitará SI Y SOLO SÍ, la agencia ya se encuentra registrada por primera vez</span>
                </div>
                <div class="form-group col-lg-12" *ngIf="isEdit">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0 table-sm">
                      <thead class="thead-default">
                        <tr>
                          <th class="nowrap w-40 w-xs-auto">Nombres y apellidos <span class="required"></span></th>
                          <th class="nowrap w-xs-auto">Celular <span class="required"></span></th>
                          <th class="nowrap w-xs-auto">Email</th>
                          <th class="text-left">Cargo</th>
                          <th class="text-left">Obs.</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="detail_managers.length == 0">
                          <tr>
                            <td colspan="2"><span>No se encontraron registros</span></td>
                          </tr>
                        </ng-container>
                        <ng-container *ngIf="detail_managers.length > 0">
                          <tr *ngFor="let item of detail_managers; let index_ = index">
                            <td class="nowrap w-40 w-xs-auto">
                              <input type="text" id="manager_fullname{{index_}}" class="form-control form-control-xs"
                                value="{{item.fullname}}" (keyup)="changeManagerFullname($event.target, index_)">
                            </td>
                            <td class="nowrap w-xs-auto">
                              <input type="text" id="manager_cellphone{{index_}}" class="form-control form-control-xs"
                                value="{{item.cellphone}}" (keyup)="changeManagerCellphone($event.target, index_)"
                                numeric>
                            </td>
                            <td>
                              <input type="text" id="manager_email{{index_}}" class="form-control form-control-xs"
                                value="{{item.email}}" (keyup)="changeManagerEmail($event.target, index_)">
                            </td>
                            <td>
                              <input type="text" id="manager_charge{{index_}}" class="form-control form-control-xs"
                                value="{{item.charge}}" (keyup)="changeManagerCharge($event.target, index_)">
                            </td>
                            <td>
                              <input type="text" id="manager_observations{{index_}}"
                                class="form-control form-control-xs" value="{{item.observations}}"
                                (keyup)="changeManagerObservations($event.target, index_)">
                            </td>
                            <td>
                              <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                (click)="removeManager(item.id, index_)"></i>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                  <a class="btn btn-info btn-sm f-s-12 text-white m-t-10" (click)="addManagerItem()">Agregar encargado.
                    <i class="fas fa-arrow-up m-l-5"></i></a>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <p class="text-center p-t-15">
                <ng-container *ngIf="item.value.url_image != null">
                  <img width="200" height="165" src="tenants/{{item.value.url_image}}" alt="Preview">
                </ng-container>
                <ng-container *ngIf="item.value.url_image == null">
                  <ng-container *ngIf="imageUrl == null">
                    <img id="output" width="200" src="/images/default.png" />
                  </ng-container>
                  <ng-container *ngIf="imageUrl != null">
                    <img width="200" height="165" [src]="imageUrl" alt="Preview">
                  </ng-container>
                </ng-container>
              </p>
              <p class="text-center">
                <label for="file" style="cursor: pointer" class="m-b-0"><i class="fas fa-upload"></i>
                  Seleccionar Imagen
                  <input id="file" type="file" (change)="onFileSelected($event)" accept=".png, .jpg, .jpeg"
                    style="visibility: hidden;">
                </label>
              </p>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
